"use strict";
/**
 * @packageDocumentation @module Dialogs
 */
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require("./create");
Object.defineProperty(exports, "create", { enumerable: true, get: function () { return create_1.create; } });
var createGroup_1 = require("./createGroup");
Object.defineProperty(exports, "createGroup", { enumerable: true, get: function () { return createGroup_1.createGroup; } });
var editGroup_1 = require("./editGroup");
Object.defineProperty(exports, "editGroup", { enumerable: true, get: function () { return editGroup_1.editGroup; } });
var get_1 = require("./get");
Object.defineProperty(exports, "get", { enumerable: true, get: function () { return get_1.get; } });
Object.defineProperty(exports, "getLoadedDialog", { enumerable: true, get: function () { return get_1.getLoadedDialog; } });
var getHistory_1 = require("./getHistory");
Object.defineProperty(exports, "getHistory", { enumerable: true, get: function () { return getHistory_1.getHistory; } });
var loadDialogsUnreadMessages_1 = require("./loadDialogsUnreadMessages");
Object.defineProperty(exports, "loadDialogsUnreadMessages", { enumerable: true, get: function () { return loadDialogsUnreadMessages_1.loadDialogsUnreadMessages; } });
var remove_1 = require("./remove");
Object.defineProperty(exports, "remove", { enumerable: true, get: function () { return remove_1.remove; } });
var leave_1 = require("./leave");
Object.defineProperty(exports, "leave", { enumerable: true, get: function () { return leave_1.leave; } });
var getOpponentIds_1 = require("./getOpponentIds");
Object.defineProperty(exports, "getOpponentIds", { enumerable: true, get: function () { return getOpponentIds_1.getOpponentIds; } });
var useUnreadDialogCounter_1 = require("./useUnreadDialogCounter");
Object.defineProperty(exports, "useUnreadDialogCounter", { enumerable: true, get: function () { return useUnreadDialogCounter_1.useUnreadDialogCounter; } });
var useAll_1 = require("./useAll");
Object.defineProperty(exports, "useAll", { enumerable: true, get: function () { return useAll_1.useAll; } });
//# sourceMappingURL=index.js.map